import ProfilePage from "../pages/UserProfile";

const routesSettings = [
  {
    path: "/profile",
    element: <ProfilePage />,
  },
];

export default routesSettings;